import { useMutation, useQuery, useQueryClient } from 'react-query'
import { api } from '../../utils/api'
import { ContentType } from '../../utils/api/tools'
import { AddressType, AddressValues } from './address-typed'

export const USER_ADDRESS_URL = '/app/userAddress'

export const CREATE_ADDRESS = `${USER_ADDRESS_URL}/createUserAddress`
export const EDIT_ADDRESS = `${USER_ADDRESS_URL}/editUserAddress`
export const GET_USER_ADDRESS_LIST = `${USER_ADDRESS_URL}/getUserAddressList`
export const GET_USER_ADDRESS = `${USER_ADDRESS_URL}/getUserAddress`

export const useCreateAddress = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async (data: AddressValues) => {
      return api.belive.post(CREATE_ADDRESS, data, { contentType: ContentType.JSON })
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([GET_USER_ADDRESS_LIST])
      },
      onError: (e: any) => {
        if (e.message) {
          console.log(e.message)
        }
      },
    },
  )
}

export const useEditAddress = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async (data: AddressValues) => {
      return api.belive.post(EDIT_ADDRESS, data, { contentType: ContentType.JSON })
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([GET_USER_ADDRESS_LIST])
      },
      onError: (e: any) => {
        if (e.message) {
          console.log(e.message)
        }
      },
    },
  )
}

export const useGetAdressList = () => {
  return useQuery<AddressType[]>(GET_USER_ADDRESS_LIST, () =>
    api.belive.get<AddressType[]>(GET_USER_ADDRESS_LIST),
  )
}

export const useGetAddressById = (addressId: number) => {
  return useQuery<AddressType>(`${GET_USER_ADDRESS}/${addressId}`, () =>
    api.belive.get<AddressType>(`${GET_USER_ADDRESS}/${addressId}`),
  )
}
